import { useDispatch } from 'react-redux';

import { type store } from 'utils/store';

const useAppDispatch: () => typeof store.instance.dispatch = () => useDispatch<typeof store.instance.dispatch>();

export { useAppDispatch };
